<template>

  <div>
    <b-card 
      :header="!noTitle ? 'Diagnostico' : ''" 
      :class="!noBorder ? 'border' : 'm-0'">

      <div class="row mb-2"  v-if="!onlyView && !noAdd">
        <div class="col-12">
          <label>Diagnostico: </label>
          <v-select
            placeholder="Escriba un diagnóstico..."
            v-model="diagnosticoTemp.diagnostico"
            :options="diagnosticosOpts"
            label="text"
            @search="onSearchDiagnosticos"
            :loading="searchDiagnosticos.loading"
          >
            <template #no-options>
              {{ noDiagnosticosMessage() }}
            </template>
          </v-select>
        </div>
        
        <b-col 
          :class="small ? 'col-6' : 'col-4'"
          class="mt-2"
        >
          <label>Escoja el tipo de diagnostico: </label>

          <v-select
            v-model="diagnosticoTemp.tipo"
            :options="tipoDiagnosticoOpts"
            label="text"
            placeholder="Escriba un diagnóstico..."
          />
        </b-col>

        <b-col 
          :class="small ? 'col-2' : 'col-1'"
          class="mt-2"
        >
          <label>Principal</label>
          <b-form-checkbox
            v-model="diagnosticoTemp.principal"
            switch
            :disabled="hiddenSwitchPrincipal"
          />
        </b-col>

        <b-col 
          class="d-flex align-items-center mt-2"
        >
          <b-button
            variant="warning"
            size="sm"
            @click="onAddDiagnostico()"
            style="cursor: pointer"
            :disabled="!isValidDiagnosticoTemp"
          >
            <strong>
              <i
                class="fas fa-solid fa-plus"
                style="margin-right: 10px"
                title="Agregar Diagnóstico"
              />
            </strong>
          </b-button>
        </b-col>
      </div>

      <b-row v-if="diagnosticosList.length > 0">
  
        <b-col cols="12">

          <span
            v-if="showMessageMax"
            class="text-danger"
          >
            Solamente se puede ingresar un maximo de 3 diagnosticos presuntivos y 3 definitivos
          </span>

          <span
            v-if="showMessageNoPrincipal"
            class="text-danger"
          >
            Debera registrar al menos un diagnostico principal para la atención
          </span>

          <b-table 
            :items="diagnosticosList" 
            :fields="fieldsTableDiagnosticos"
            responsive
          >
            <template #cell(index)="data">
              {{ data.index + 1 }}
            </template>
            <template #cell(diagnostico)="data">
              {{ data.item.diagnostico.text }}
            </template>
            <template #cell(tipo)="data">
              {{ data.item.tipo.text }}
            </template>
            <template #cell(principal)="data">
              {{ data.item.principal ? "Sí" : "No" }}
            </template>
            <template #cell(acciones)="data"  v-if="!onlyView">

              <div class="d-flex">
                <b-button
                  v-if="!noEditItems"
                  variant="info"
                  size="sm"
                  title="Editar Diagnostico"
                  @click="onEditDiagnostico(data.index)"
                >
                  <i class="fa-solid fa-pen"/>
                </b-button>

                <b-button
                  variant="danger"
                  size="sm"
                  @click="onRemoveDiagnostico(data.index)"
                >
                  <font-awesome-icon icon="circle-xmark" />
                </b-button>
              </div>

              
            </template>
          </b-table>
        </b-col>
      </b-row>

      <b-row v-if="diagnosticosList.length === 0">
        <b-alert show variant="danger" class="p-3 col-12 text-center" style="font-size: 18px">
          <i class="fa-solid fa-triangle-exclamation mr-1"/>
          <span class="text-danger">No se han agregado diagnosticos</span>
        </b-alert>
      </b-row>

      <b-row v-if="diagnosticosDelete.length > 0 && showDeleted" class="mt-2">
        <h6 class="col-8 text-warning text-center">Diagnosticos Eliminados</h6>
        <b-table
          class="col-8"
          :items="diagnosticosDelete" 
          :fields="fieldsTableDiagnosticos"
          responsive 
          table-variant="warning"
          head-row-variant="warning"
          head-variant="none"
        >
          <template #cell(index)="data">
            {{ data.index + 1 }}
          </template>
          <template #cell(diagnostico)="data">
            {{ data.item.diagnostico.text }}
          </template>
          <template #cell(tipo)="data">
            {{ data.item.tipo.text }}
          </template>
          <template #cell(principal)="data">
            {{ data.item.principal ? "Sí" : "No" }}
          </template>
          <template #cell(acciones)="data"  v-if="!onlyView">

            <div class="d-flex">
              
              <b-button
                variant="warning"
                size="sm"
                title="Restaurar Diagnostico"
                @click="onRestoreDiagnostico(data.index)"
              >
                <i class="fa-solid fa-rotate-left"/>
              </b-button>
            </div>

            
          </template>
        </b-table>
      </b-row>
      
    </b-card>

    <DiagnosticoModalEdit 
      v-model="indexDiagnosticoEdit"
      :diagnosticosList="diagnosticosList"
    />
  </div>
  
</template>

<script>

import vSelect from "vue-select";
import { diagnosticosService } from '@/views/atencionMedica/services';
import { debounce }           from '@/shared/helpers/debounce';
import { mapState }           from 'vuex';
import DiagnosticoModalEdit   from './DiagnosticoModalEdit.vue';

export default {

  name: 'DiagnosticosList',

  components: {
    vSelect,
    DiagnosticoModalEdit
  },

  props: {
    value: {
      type: Array,
      required: true
    },

    onlyView: {
      type: Boolean,
      default: false
    },

    noTitle: {
      type: Boolean,
      default: false
    },

    noBorder: {
      type: Boolean,
      default: false
    },

    small: {
      type: Boolean,
      default: false
    },

    noAdd: {
      type: Boolean,
      default: false
    },

    noEditItems: {
      type: Boolean,
      default: false
    },

    showDeleted: {
      type: Boolean,
      default: false
    }
  },

  data(){

    return {
      diagnosticoTemp: { principal : false },
      diagnosticosList: this.value || [],
      diagnosticosDelete: [],
      isValidDiagnosticoTemp: false,
      

      searchDiagnosticos:{
        query:'',
        isLoading:false,
        searchFailed:false,
        selected:null       
      },

      diagnosticosOpts: [],
      tipoDiagnosticoOpts: [],

      showMessageMax: false,

      indexDiagnosticoEdit: null,

      showMessageNoPrincipal: false
    }
  },

  created() {
    this.onSearchDiagnosticos = debounce(this.onSearchDiagnosticos, 2000);
    this.loadDataInit();
  },

  methods: {

    async loadDataInit(){
      this.tipoDiagnosticoOpts = await diagnosticosService.getTiposSelect();
    },

    //diagnosticos
    noDiagnosticosMessage() {
      if (this.searchDiagnosticos.query.length <= 3) 
        return 'Escribe más caracteres para buscar...';

      if (this.searchDiagnosticos.isLoading) 
        return 'Buscando diagnosticos...';
      
      if (this.searchDiagnosticos.searchFailed) 
        return 'Error al buscar diagnosticos. Intente de nuevo.';
      
      if (this.diagnosticosOpts.length === 0 && !this.isLoading) 
        return 'No se encontraron diagnosticos que coincidan con tu búsqueda';
      
      return 'Escribe para buscar diagnosticos...';
    },

    async onSearchDiagnosticos(query) {
      this.searchDiagnosticos.query = query;

      if(query.length < 2) {
        this.diagnosticosOpts = []; 
        return;
      }

      this.searchDiagnosticos.isLoading = true;
      this.diagnosticosOpts = [];
      this.diagnosticosOpts = await this.filterDiagnosticos(query);
      this.searchDiagnosticos.isLoading = false;
    },

    async filterDiagnosticos(query){
      const diagnosticos = await diagnosticosService.getByQuerySelect(query);
      const diagnosticoListIds = this.diagnosticosList.map( d => d.diagnostico.value );
      return diagnosticos.filter( d => !diagnosticoListIds.includes(d.value) );
    },

    onAddDiagnostico(){
      this.diagnosticosList.push( this.diagnosticoTemp );
      this.diagnosticoTemp = {
        diagnostico:null,
        tipo:null,
        principal: false,
        validate:false,
      }
    },


    onEditDiagnostico(index){
      this.indexDiagnosticoEdit = index;
    },


    onRestoreDiagnostico(index){
      this.diagnosticosList.push( this.diagnosticosDelete[index] );
      this.diagnosticosDelete.splice(index, 1);
    },

    onRemoveDiagnostico(index){
      this.$swal({
        title: "¿Estás seguro de eliminar este ítem?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar!",
        cancelButtonText: "Cancelar",
      })
        .then((result) => {
          if (result.isConfirmed) {
            this.diagnosticosDelete.push( this.diagnosticosList[index] );
            this.diagnosticosList.splice(index, 1);
            this.$swal("Eliminado!", "El ítem ha sido eliminado.", "success");
          }
        })
        .catch((error) => {
          console.error("Error al eliminar el ítem:", error);

          this.$swal(
            "Error",
            "Ocurrió un error al intentar eliminar el ítem.",
            "error"
          );
        });
    },
  },
  

  computed: {
    ...mapState({
      stDiagnosticos: state => state.atencionCita.anamnesis.diagnostico,
    }),

    hiddenSwitchPrincipal(){

      // validar diagnosticos con r
      const codigoDiagnostico = this.diagnosticoTemp?.diagnostico?.codigo
      if(codigoDiagnostico){
        const firstChar = codigoDiagnostico[0];
        if(firstChar === 'R' || firstChar === 'r') return true
      }
      
      return this.diagnosticosList.some( item => item.principal === true )
    },

    fieldsTableDiagnosticos() {
      const baseFields = [
        { key: "index",       label: "N°",                 thClass: "text-center", tdClass: "text-center" },
        { key: "diagnostico", label: "Descripcion/Codigo", thClass: "text-center" },
        { key: "tipo",        label: "Tipo",               thClass: "text-center" },
        { key: "principal",   label: "Principal",          thClass: "text-center", tdClass: "text-center" },
      ];
      
      if (this.onlyView) {
        return baseFields;
      }
      
      return [...baseFields, { key: "acciones", label: "Acciones", thClass: "text-center", tdClass: "text-center" }];
    },

    nPresuntivos() {
      return this.diagnosticosList.filter( d => d.tipo.value === '1' ).length;
    },

    nDefinitivos() {
      return this.diagnosticosList.filter( d => d.tipo.value === '2' ).length;
    }

  },

  watch: {
    diagnosticosList: {
      handler(newVal) {
        this.$emit('input', newVal);

        if(!newVal || !newVal.length) {
          this.showMessageNoPrincipal = false;
          return;
        }
        
        const hasPrincipal = newVal.find( d => d.principal);
        this.showMessageNoPrincipal = !hasPrincipal;
      },
      deep: true
    },

    diagnosticoTemp: {
      deep: true,
      handler(newVal) {
        const maxPresuntivos = newVal.tipo?.value === '1' && this.nPresuntivos === 3;
        const maxDefinitivos = newVal.tipo?.value === '2' && this.nDefinitivos === 3;
        this.showMessageMax = maxPresuntivos || maxDefinitivos;
        
        this.isValidDiagnosticoTemp = !!newVal.diagnostico 
        && !!newVal.tipo 
        && !maxPresuntivos 
        && !maxDefinitivos;
      }
    },

    // stDiagnosticos: {
    //   deep: true,
    //   handler(newValue) {
    //     this.diagnosticosList = newValue;
    //   },
    // }
  },
}
</script>

<style>
  .border{
    border: 1px solid #c9c9c9;
  }
</style>